module.exports = __webpack_public_path__ + "img/ltkover40-4x.1ec5386.jpg";